import React from 'react';
import { usePerformanceData } from './hooks/usePerformanceData';
import { RequestsView } from './views/RequestsView';
import { MemoryView } from './views/MemoryView';
import { CollapsedView } from './views/CollapsedView';
import { BulletWarningsView } from './views/BulletWarningsView';
import { SqlView } from './views/SqlView';

// Main component that orchestrates the performance data monitoring UI
export const PerformanceDataListener: React.FC = () => {
  const {
    isVisible,
    viewState,
    requests,
    handleGoBack,
    handleClose,
    handleSelectRequest,
    getSelectedRequest,
    setViewState
  } = usePerformanceData();

  if (!isVisible || requests.length === 0) {
    return null;
  }

  switch (viewState.mode) {
    case 'collapsed':
      return <CollapsedView requests={requests} onExpand={() => setViewState({ mode: 'requests' })} />;

    case 'requests':
      return (
        <RequestsView
          requests={requests}
          onSelectRequest={handleSelectRequest}
          onBack={handleGoBack}
          onClose={handleClose}
        />
      );

    case 'bullet': {
      const selectedRequest = getSelectedRequest();
      return selectedRequest ? (
        <BulletWarningsView request={selectedRequest} onBack={handleGoBack} onClose={handleClose} />
      ) : null;
    }

    case 'memory': {
      const selectedRequest = getSelectedRequest();
      return selectedRequest ? (
        <MemoryView request={selectedRequest} onBack={handleGoBack} onClose={handleClose} />
      ) : null;
    }

    case 'sql': {
      const selectedRequest = getSelectedRequest();
      return selectedRequest ? (
        <SqlView
          request={selectedRequest}
          selectedSqlId={viewState.selectedSqlId || 0}
          onBack={handleGoBack}
          onClose={handleClose}
        />
      ) : null;
    }

    default:
      return null;
  }
};
